//i18n-setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import PL from './i18n/pl.json'
import EN from './i18n/en.json'

import { configure } from "vee-validate";

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: {
    en: {
      ...EN
    },
    pl: {
      ...PL
    }
  }
});

configure({
  // this will be used to generate messages.
  defaultMessage: (_, values) =>
    i18n.t(`validations.messages.${values._rule_}`, values)
});


export default i18n;